import { render, staticRenderFns } from "./BaseModalForm.vue?vue&type=template&id=6ab3af69&"
import script from "./BaseModalForm.vue?vue&type=script&lang=ts&"
export * from "./BaseModalForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports